import { useSelector } from 'react-redux'
import { IAlphaprocessState } from '../store'

// Development builds only: localStorage "alphaprocess.newDesign" = "1" forces the new design on,
// e.g. to look at real data with a local frontend against the production backend before the
// backend knows the setting.
export function forcedNewDesign(): boolean {
  if (process.env.NODE_ENV !== 'development') return false
  try {
    return localStorage.getItem('alphaprocess.newDesign') === '1'
  } catch {
    return false
  }
}

// the new design (redesign round 1): the user's own choice, else the company setting (backend
// User#new_design_enabled?). Screens switch on this one by one, the old design stays the default.
export default function useNewDesign(): boolean {
  const enabled = useSelector((state: IAlphaprocessState) => (state.core.user
    ? !!state.core.user.new_design_enabled
    : !!state.core.visitorNewDesign))
  return enabled || forcedNewDesign()
}
